import { useMemo } from 'react'
import { useAccount } from 'wagmi'
import { useReadPepperContract } from './useReadPepperContract'
import { useStaking2aAddress } from '../staking2a-contract/useStaking2aContract'

/*
 * Fetches the user's allowance on the Staking contract
 * @returns The user's allowance on the Staking contract
 */
export function usePepperUserAllowanceOnStaking() {
	const { address: ownerAddress } = useAccount()
	const spenderAddress = useStaking2aAddress()

	return useReadPepperContract({
		functionName: 'allowance',
		args: [ownerAddress ?? '0x', spenderAddress]
	})
}
